var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",style:(_vm.selfStyle)},[_c('div',{staticClass:"card-body"},_vm._l((_vm.datas),function(item){return _c('Stick',{key:item.nid,attrs:{"item":item}})}),1),_c('Loading',{attrs:{"loading":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }